// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"31oao":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JumblePageElement", ()=>JumblePageElement);
var _tsDecorate = require("@swc/helpers/_/_ts_decorate");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _form = require("../css/form");
var _reset = require("../css/reset");
var _stack = require("../css/stack");
var _type = require("../css/type");
var _wordList = require("../wordList");
var _wordListElement = require("../wordListElement");
var _spellingBee = require("./spellingBee");
var _cluster = require("../css/cluster");
// Only lower case letters.
const normalizeInput = (pattern)=>pattern.toLowerCase().replace(/[^a-z]/g, "");
class JumblePageElement extends (0, _lit.LitElement) {
    constructor(){
        super();
        this.loading = true;
        this.centerLetter = "b";
        this.outerLetters = "erimsp";
        this.solutions = [];
        this.spellingBee = (0, _wordList.wordListPromise).then((words)=>new (0, _spellingBee.SpellingBee)(words));
        this.updateWords();
    }
    onCenterLetterChange(event) {
        const target = event.target;
        target.value = normalizeInput(target.value);
        this.centerLetter = target.value;
        this.updateWords();
    }
    onOuterLettersChange(event) {
        const target = event.target;
        target.value = normalizeInput(target.value);
        this.outerLetters = target.value;
        this.updateWords();
    }
    async updateWords() {
        this.loading = true;
        const spellingBee = await this.spellingBee;
        this.solutions = spellingBee.matches(this.centerLetter, this.outerLetters);
        this.loading = false;
    }
    static get styles() {
        return [
            (0, _reset.resetCss),
            (0, _stack.stackCss),
            (0, _cluster.clusterCss),
            (0, _type.typeCss),
            (0, _form.formCss),
            (0, _lit.css)`
        .cluster { gap: var(--space-md); }
        #center-letter { width: 3ch; text-align: center; }
        #outer-letters { width: 8ch; text-align: center; }
        :invalid {
          background: #ffdfdf;
        }
      `
        ];
    }
    render() {
        return (0, _lit.html)`
      <div class="stack">
        <p>
          Enter the letters for a <a
          href="https://www.nytimes.com/puzzles/spelling-bee">Spelling Bee</a>
          puzzle to see potential solutions.
        </p>

        <div class="cluster">
          <div>
            <label for="center-letter">Center letter</label>
            <input
                id="center-letter"
                class="puzzle-input"
                autofocus
                required
                maxlength="1"
                spellcheck="false"
                .value="${this.centerLetter}"
                @input="${this.onCenterLetterChange}">
          </div>

          <div>
            <label for="outer-letters">Six outer letters</label>
            <input
                id="outer-letters"
                class="puzzle-input"
                spellcheck="false"
                required
                minlength="6"
                maxlength="6"
                .value="${this.outerLetters}"
                @input="${this.onOuterLettersChange}">
          </div>
        </div>

        ${!this.centerLetter ? (0, _lit.html)`<p>Enter the puzzle's center letter.</p>` : ""}
        ${!this.outerLetters ? (0, _lit.html)`<p>Enter the puzzle's six outer letters.</p>` : ""}

        <div>
          <h2>${this.solutions.length} potential words</h2>

          ${this.loading ? (0, _lit.html)`<p>Loading&hellip;</p>` : null}

          ${!this.loading && this.outerLetters.length && this.solutions.length === 0 ? (0, _lit.html)`
            <p>
              🤔 We can't find a way to make words with these letters.
              "${this.outerLetters}".
            </p>
          ` : null}

          <mw-word-list .words="${this.solutions}"></mw-word-list>
        </div>
      </div>
    `;
    }
}
(0, _tsDecorate._)([
    (0, _decoratorsJs.state)()
], JumblePageElement.prototype, "loading", void 0);
(0, _tsDecorate._)([
    (0, _decoratorsJs.state)()
], JumblePageElement.prototype, "centerLetter", void 0);
(0, _tsDecorate._)([
    (0, _decoratorsJs.state)()
], JumblePageElement.prototype, "outerLetters", void 0);
(0, _tsDecorate._)([
    (0, _decoratorsJs.state)()
], JumblePageElement.prototype, "solutions", void 0);
JumblePageElement = (0, _tsDecorate._)([
    (0, _decoratorsJs.customElement)("mw-spelling-bee-page")
], JumblePageElement);

},{"@swc/helpers/_/_ts_decorate":"3Z6vO","lit":"aCmte","lit/decorators.js":"kQrIl","../css/form":"8MMj0","../css/reset":"lBn3n","../css/stack":"812mT","../css/type":"9FxKK","../wordList":"5Ye1N","../wordListElement":"4NDBJ","./spellingBee":"ePSrU","../css/cluster":"bGJDG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ePSrU":[function(require,module,exports) {
/**
 * Given a lexicon, creates an accelerator for looking up Spelling Bee
 * solutions.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SpellingBee", ()=>SpellingBee);
class SpellingBee {
    constructor(words){
        // Solutions must be 4 letters or more. Discard too-short words.
        this.words = words.filter((w)=>w.length >= 4);
    }
    matches(centerLetter, outerLetters) {
        const allowedLetters = [
            ...centerLetter,
            ...outerLetters
        ];
        return this.words.filter((candidate)=>candidate.includes(centerLetter) && [
                ...candidate
            ].every((candidateLetter)=>allowedLetters.includes(candidateLetter)));
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bGJDG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clusterCss", ()=>clusterCss);
var _lit = require("lit");
const clusterCss = (0, _lit.css)`
  .cluster {
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-xs);
  }

  .cluster--space-between {
    justify-content: space-between;
  }

  .cluster--flex-end {
    justify-content: flex-end;
  }
`;

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}]},["31oao"], "31oao", "parcelRequire85a9")

//# sourceMappingURL=index.848b51ff.js.map
